const platformSets=[
  ['instagram'],
  ['linkedin'],
  ['facebook'],
  ['instagram','linkedin'],
  ['instagram','facebook']
];

function hashValue(value) {
  return String(value)
    .split('')
    .reduce((total,character,index)=> (
      total+(character.charCodeAt(0)*(index+11))
    ),0);
}

export function createMockEngagement(postId,platformCount=1) {
  const seed=hashValue(postId);
  const multiplier=Math.max(platformCount,1);

  return {
    likes:48+(seed%310)+(multiplier*19),
    comments:4+(seed%38)+(multiplier*2),
    reach:780+(seed%4700)+(multiplier*420)
  };
}

export function hydratePublishedPost(post) {
  if (post.status!=='posted') {
    return post;
  }

  const seed=hashValue(post.id);
  const publishedPlatforms=post.publishedPlatforms?.length
    ? post.publishedPlatforms
    : platformSets[seed%platformSets.length];

  return {
    ...post,
    publishedPlatforms,
    engagement:post.engagement || createMockEngagement(
      post.id,
      publishedPlatforms.length
    )
  };
}

export function getEngagementScore(engagement) {
  if (!engagement) {
    return 0;
  }

  return engagement.likes+(engagement.comments*4);
}

export function formatMetric(value) {
  if (value>=1000000) {
    return `${(value/1000000).toFixed(1).replace('.0','')}M`;
  }

  if (value>=1000) {
    return `${(value/1000).toFixed(1).replace('.0','')}K`;
  }

  return String(value);
}